import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../ricos-context/index.js";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider.js";
import { DropdownButton } from "./../dropdown-button.js";
import { NODE_SIZE_BUTTONS } from "./consts.js";
import { NodeSizeDropdown } from "./node-size-dropdown.js";
const NodeSizeButton = ({ toolbarItem, dataHook, id, options }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalServiceContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedSize = () => toolbarItem?.attributes.nodeSize || "CONTENT";
  const onClick = () => {
    modalService.isModalOpen(id) ? modalService.closeModal(id) : modalService.openModal({
      id,
      Component: NodeSizeDropdown,
      componentProps: {
        modalId: id,
        getSelectedSize,
        onClick: (size) => {
          toolbarItem.commands?.setSize({ value: size });
          modalService.closeModal(id);
        },
        options
      },
      layout: isMobile ? "drawer" : "floating",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      icon: NODE_SIZE_BUTTONS[getSelectedSize()].icon,
      ref: setReferenceElement,
      tooltip: t("ButtonModal_Size_Section"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  NodeSizeButton
};
//# sourceMappingURL=node-size-button.js.map
